import { apiClient } from './client.js';

export const lessonApi = {
  getLessonDetails: (id) => apiClient.get(`/lessons/${id}`),
  createLesson: (arg1, arg2) => {
    if (typeof arg1 === 'object' && arg1 !== null) {
      const { courseId, ...data } = arg1;
      return apiClient.post(`/courses/${courseId}/lessons`, data);
    }
    return apiClient.post(`/courses/${arg1}/lessons`, arg2);
  },
  updateLesson: (id, data) => apiClient.patch(`/lessons/${id}`, data),
  deleteLesson: (id) => apiClient.delete(`/lessons/${id}`),
  // Bài tập thực hành (HT-06 F-04)
  getMyAssignmentSubmission: (id) => apiClient.get(`/lessons/${id}/assignment-submission`),
  submitAssignment: (id, content) => apiClient.put(`/lessons/${id}/assignment-submission`, { content }),
  getAssignmentSubmissions: (id) => apiClient.get(`/lessons/${id}/assignment-submissions`),
};
